// frontend_app/src/data/usefulLinks.js
//
// This is the central file for managing the "Useful Links" panel.
// To add a new link, simply add it to the `links` array within a category.
// To add a new category, copy the structure of an existing category object.
// All links will automatically open in a new tab.

export const usefulLinksData = [
  {
    category: "Australian Pathology Databases",
    links: [
      { name: "LGH Test DB", url: "http://pathology.health.local/ntps/TestDB/default.asp" },
      { name: "RHH Test DB", url: "http://pathology.health.local/testinfo/external/" },
      { name: "Alfred Health", url: "https://pathology.alfred.org.au/handbook/" },
      { name: "Austin Pathology", url: "https://austinpathology.org.au/test-directory" },
      { name: "Australian Clinical Labs (ACL)", url: "https://www.clinicallabs.com.au/doctor/testing-guide/collection-manual/" },
      { name: "Healius (Dorevitch & TML)", url: "https://www.tmlpath.com.au/clinicians/test-reference-manual/" },
      { name: "Mater Pathology (QLD)", url: "https://pathtest.mater.org.au/PathTestDisplay/List" },
      { name: "Monash Health Pathology", url: "https://handbook.monashpathology.org/" },
      { name: "NSW Health Pathology", url: "https://catalogue.pathology.health.nsw.gov.au/home" },
      { name: "NutriPATH", url: "https://nutripath.com.au/?s" },
      { name: "Pathology Queensland", url: "https://www.health.qld.gov.au/public-health/pathology-queensland/healthcare/testing/test-list" },
      { name: "PathWest (WA)", url: "https://pathwesttd.health.wa.gov.au/testdirectory/" },
      { name: "Royal Children's Hospital (RCH)", url: "https://www.rch.org.au/specimen-collection/" },
      { name: "Royal Melbourne Hospital (RMH)", url: "https://www.thermh.org.au/health-professionals/for-gps/pathology-handbook" },
      { name: "SA Pathology", url: "https://www.sapathology.sa.gov.au/wps/wcm/connect/SA+Pathology+Internet+Content+New/Content/Clinicians/Pathology+Collection+Guide/" },
      { name: "Sonic (LP, HOB)", url: "https://testmanual.sonichealthcare.com/dsp" },
      { name: "Sonic (Melbourne Pathology)", url: "https://testmanual.sonichealthcare.com/mps" },
      { name: "Sonic (DHM)", url: "https://testmanual.sonichealthcare.com/dhm" },
      { name: "Sonic (SNP)", url: "https://testmanual.sonichealthcare.com/snp" },
      { name: "St Vincent's Pathology (Melbourne)", url: "http://pathmanual.svhm.org.au/" },
      { name: "SydPath (St Vincent's NSW)", url: "https://sydpath.com.au/test-offered/" },
      { name: "Victorian Clinical Genetics Services (VCGS)", url: "https://www.vcgs.org.au/test-and-specimen-directory/" },
      { name: "VIDRL", url: "https://www.vidrl.org.au/test-handbook/" },
      { name: "Victorian Transfusion & Immunohaematology Service (VTIS)", url: "https://handbook.northernpath.org.au/" },
      

    ]
  },
  {
    category: "Specialty & Genetics",
    links: [
      { name: "Panel App - Genes", url: "https://panelapp-aus.org/panels/entities/" },
      { name: "Panel App - Panels", url: "https://panelapp-aus.org/panels/" },
      { name: "Gene - NCBI", url: "https://www.ncbi.nlm.nih.gov/gene/" },
      { name: "Genomics For Life", url: "https://genomicsforlife.com.au/" },
      { name: "Peter Mac - Molecular Haematology", url: "https://www.petermac.org/health-professionals/services-for-health-professionals/pathology-health-professionals/molecular-pathology/molecular-haematology" },
      { name: "Peter Mac - Germline Testing", url: "https://www.petermac.org/health-professionals/services-for-health-professionals/pathology-health-professionals/molecular-pathology/germline-testing" },
      { name: "Peter Mac - Somatic/Molecular Oncology", url: "https://www.petermac.org/health-professionals/services-for-health-professionals/pathology-health-professionals/molecular-pathology/somatic-testing" },
      { name: "PathWest - Neuromuscular Gene Panel", url: "https://pathwest.health.wa.gov.au/~/media/PathWest/Documents/Our-Services/Clinical-Services/Diagnostic-Genomics/Neuromuscular-gene-panel-Muscle-v6-gene-list-boxed-180821.pdf" },
      { name: "RCPA - Genetic Tests & Laboratories", url: "https://www.rcpa.edu.au/Manuals/RGTL" },
      { name: "Sonic Genetics", url: "https://www.sonicgenetics.com.au/our-tests/all-our-tests/" },
      { name: "VCGS Prepair 500+ Panel", url: "https://panelapp.agha.umccr.org/panels/4225/" },
      { name: "VCGS Prepair 1000+ Panel", url: "https://panelapp.agha.umccr.org/panels/3861/" },
      { name: "Westmead Children's Hospital", url: "https://www.schn.health.nsw.gov.au/clinical-hub/laboratory-services/biochemical-genetics-service/tests-available" },

    ]
  },
  {
    category: "International Databases",
    links: [
      { name: "Pathlab (NZ)", url: "https://tests.pathlab.co.nz/?keywords=antiquitin" },
      { name: "Waikato (NZ)", url: "https://lab.waikatodhb.health.nz/test-guide" },
    ]
  },
  {
    category: "Clinical Resources & Forms",
    links: [
      { name: "Autoantibody Guide (DHM)", url: "https://www.dhm.com.au/media/Multisite8736/dhm_information-for-clinicians_autoantibodies_201810.pdf" },
      { name: "Dorevitch Collection Guide (PDF)", url: "https://webapi.healius.com.au/redirect/4c674c01-dbcf-4c6c-983e-33f889af77c6.pdf" },
      { name: "Lifeblood - Forms", url: "https://www.lifeblood.com.au/health-professionals/forms" },
      { name: "Pathology Tests Explained", url: "https://pathologytestsexplained.org.au/" },
      { name: "Peter Mac - Molecular Request Form (PDF)", url: "https://www.rch.org.au/uploadedFiles/Main/Pages/Specimen_Collection/SR-E-037_PMCC%20-%20Molecular%20Haematology%20Request%20Form.pdf" },
      { name: "RCPA Manual - Pathology Tests", url: "https://www.rcpa.edu.au/Manuals/RCPA-Manual/Pathology-Tests" },
      { name: "VCGS - Forms & Resources", url: "https://www.vcgs.org.au/forms-and-resources/" },
      { name: "VCGS Prepair Form", url: "https://www.vcgs.org.au/prepair-medicare/" },
      { name: "VTIS Sample Requirements (PDF)", url: "https://transfusion.com.au/system/files/resource_library/INF-00104%20VTIS%20Sample%20Requirements%20v2.pdf" },
    ]
  },
  {
    category: "Misc & Contacts",
    links: [
      { name: "BloodNet", url: "https://www.bloodnet.blood.gov.au/" },
      { name: "Concord Hospital Contacts", url: "https://www.slhd.nsw.gov.au/concord/department-pathology-contact.html" },
      { name: "myQAP Portal", url: "https://myqap.rcpaqap.com.au/login" },
    ]
  }
];